const initialState = {
 	datos: {},
 	dataChanges: {},
 	loading: true,
 	error: null,
 	status: null,
 	backgroundFetch: {
 		loading: false,
 		status: null,
 		error: null
 	},
 	validateFlow: {
 		loading: false,
 		status: null,
 		error: null,
 		data: {}
 	},
 	saveFlowActions: {
 		loading: false,
 		status: null,
 		error: null,
 		data: {}
 	},
 	saveStats: {
 		loading: false,
 		status: null,
 		error: null,
 		data: {}
 	}
};

 export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/flow_admin_detail/initialState.js